import { render, staticRenderFns } from "./TranslationConfig.vue?vue&type=template&id=230b106b"
import script from "./TranslationConfig.vue?vue&type=script&lang=js"
export * from "./TranslationConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports